import React, { memo } from "react";
import styles from "./text-tabs.module.scss";

export interface TextTabItem {
	title: string;
	badge?: boolean;
	disabled?: boolean;
	onTap: () => void;
}

interface TextTabsProps {
	tabs: TextTabItem[];
	selectedIndex: number;
}

const TextTabs: React.FC<TextTabsProps> = memo(({ tabs, selectedIndex }) => {
	return (
		<div className={styles.container}>
			{tabs.map((tab, index) => (
				<button
					key={index}
					className={`${styles.tab} ${index === selectedIndex ? styles.tabSelected : ""} ${tab.disabled ? styles.tabDisabled : ""}`}
					onClick={tab.onTap}
					disabled={tab.disabled}
				>
					{tab.title}
					{tab.badge && <span className={styles.badge} />}
				</button>
			))}
		</div>
	);
});

export default TextTabs;
